const LOCAL_STORE_JWT = "chim_jwt";

export { LOCAL_STORE_JWT };
